import ManagementRegimes from './ManagementRegimes'

export default ManagementRegimes
